/**
 * Paint Lipscore stars into .lipscore-rating widgets when Lipscore's
 * initWidgets does not run (common on article/blog templates).
 */
(function () {
  var API_KEY = '1462f23f8a9b0eb8fa1b5d0e';
  var painted = new WeakSet();

  function starSpan(filled) {
    return (
      '<span style="color:' +
      (filled ? '#17A9A3' : '#ddd') +
      ';font-size:16px;line-height:1;">★</span>'
    );
  }

  function renderRating(score10, votes) {
    var stars5 = Math.max(0, Math.min(5, Number(score10) / 2));
    var full = Math.floor(stars5);
    var half = stars5 - full >= 0.25 && stars5 - full < 0.75;
    var html = '<div style="display:flex;align-items:center;gap:4px;font-size:13px;">';
    html += '<span style="display:flex;align-items:center;">';
    for (var i = 0; i < 5; i++) {
      if (i < full) html += starSpan(true);
      else if (i === full && half) {
        html +=
          '<span style="position:relative;display:inline-block;width:16px;height:16px;line-height:1;">' +
          '<span style="color:#ddd;font-size:16px;">★</span>' +
          '<span style="color:#17A9A3;font-size:16px;position:absolute;left:0;top:0;width:50%;overflow:hidden;">★</span>' +
          '</span>';
      } else html += starSpan(false);
    }
    html += '</span>';
    html +=
      '<span style="font-weight:600;color:#17A9A3;">' +
      stars5.toFixed(1).replace('.', ',') +
      '</span>';
    if (votes != null) {
      html += '<span style="color:#888;">(' + votes + ')</span>';
    }
    html += '</div>';
    return html;
  }

  function fetchProduct(widget) {
    if (painted.has(widget)) return;
    var productId = widget.getAttribute('data-ls-product-id');
    var sku = widget.getAttribute('data-ls-sku') || '';
    if (!productId) return;
    painted.add(widget);

    var url =
      'https://wapi.lipscore.com/initial_data/products/show?api_key=' +
      encodeURIComponent(API_KEY) +
      '&sku=' +
      encodeURIComponent(sku) +
      '&internal_id=' +
      encodeURIComponent(productId) +
      '&widgets=r&translate_to_lang=no';

    fetch(url, { credentials: 'omit' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || data.lipscore == null || Number(data.votes) <= 0) {
          var wrapper = widget.closest('.product-card__rating-wrapper');
          if (wrapper) wrapper.style.display = 'none';
          return;
        }
        widget.innerHTML = renderRating(data.lipscore, data.votes);
        var wrap = widget.closest('.product-card__rating-wrapper');
        if (wrap) {
          wrap.style.display = '';
          wrap.style.visibility = 'visible';
        }
      })
      .catch(function () {
        painted.delete(widget);
      });
  }

  function paintAll() {
    document.querySelectorAll('.lipscore-rating').forEach(function (widget) {
      if (widget.children.length > 0 && widget.textContent.trim()) return;
      fetchProduct(widget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(paintAll, 200);
      setTimeout(paintAll, 1200);
    });
  } else {
    setTimeout(paintAll, 200);
    setTimeout(paintAll, 1200);
  }

  // Expose for manual refresh after dynamic inserts
  window.beautyheavenPaintLipscoreCards = paintAll;
})();
